export default class InputPrice {
    constructor(el) {
        this.el = el;
        this.mask = null;
        this.createImask();

    }
    createImask() {
        this.mask = IMask(this.el, {
            mask: Number,
            thousandsSeparator: ' ',
            min: 0
        });
        this.el.mask = this.mask


    }

}
